import { Box, Button, Grid, Toolbar, Typography, Container } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

import BackLink from "../Components/BackLink";
import {ReactComponent as BookmarkIcon} from '../Icons/Bookmark.svg';
import React from "react";
import { generatePathMyList } from "../Utils/Routes";

const useStyles = makeStyles((theme) => ({
    header: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.light,
    },
    subHeaderGridWrap: {
        paddingLeft: theme.spacing(0),
        paddingRight: theme.spacing(0),
        [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(5),
            paddingRight: theme.spacing(5),
        },
    },
    titleContainer: {
        textAlign: "center",
    },
    title: {
        textTransform: "uppercase",
        lineHeight: '24px',
        color: theme.palette.secondary.contrastText
    },
    myListContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        '& .MuiTypography-root': {
            paddingLeft: theme.spacing(1)
        },
    },
    myListCountText: {
        color: theme.palette.primary.main
    }

}))

export default function EntryHeader (props) {
    const classes = useStyles();
    const { isMobile } = props

    const disableMyListButton = props.disableMyListButton ? true : false
    return (
        <>
            <Toolbar disableGutters={true} className={classes.header}>
                <Container maxWidth="xl">
                    <Grid container direction="row" justifyContent="center" alignItems="center" className={classes.subHeaderGridWrap}>
                        <Grid item md={2} lg={2} xs={2} sm={2}>
                            <BackLink to={props.backUrl} />
                        </Grid>
                        <Grid item md={8} lg={8} xs={8} sm={8} className={classes.titleContainer}>
                            <Typography component="h6" variant="h6" className={classes.title}>{props.title}</Typography>
                        </Grid>
                        <Grid item md={2} lg={2} xs={2} sm={2}>
                            { !disableMyListButton &&
                            <Box className={classes.myListContainer} direction="row" justify-content="flex-end" alignItems="flex-end">
                                <Button disableFocusRipple href={ generatePathMyList() }>
                                    <BookmarkIcon/>
                                    {!isMobile &&
                                    <Typography component="h6" variant="button"> MY LIST </Typography>
                                    }
                                    {/*<Typography className={classes.myListCountText} component="h6" variant="button"> {props.number} </Typography>*/}
                                </Button>
                            </Box>
                            }
                        </Grid>
                    </Grid>
                </Container>
            </Toolbar>
        </>
    )
}